import React from 'react'
import ReactPlayer from 'react-player';
import PlayIcon from '../../svg/PlayIcon';

const API_URL = process.env.REACT_APP_API_URL;
const TOKEN = localStorage.getItem('token');

const PreviewVideo = ({ type = 'wide', url }) => {

    return (
        <div className={`${type}-video-preview`}>
            <ReactPlayer
                url={API_URL + url} // Video de ejemplo
                // config={{
                //     file: {
                //         headers: {
                //             Authorization: `Bearer ${TOKEN}`
                //         }
                //     }
                // }}
            // light={true}
            />
            <button className='default-buttons play-icon'>
                <PlayIcon />
            </button>
        </div>
    )
}

export default PreviewVideo